import React from 'react';
import {Button,Badge} from 'reactstrap';
import {LoadingAudio} from './Loading';
import {getAudioId} from '../functions/dashboard';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Redirect } from 'react-router';
import { baseUrl } from '../shared/baseUrl';


class AudioVerification extends React.Component{
    constructor(props){
        super(props);
        this.state={
            fetchedAudio:null,
            dropdownOpen: false,
            language: localStorage.getItem('language') || 'ENG',

            // wavPlayback
            playbackText:"Play",
            faClass:"ml-1 fa fa-play",
            isPlaying:false,

            // Count number of verifications
            verifyCount:"Loading...",
            audioId:null
        }
        this.verifyAudio = React.createRef();
    }

    toggleDropdown = () => {
        this.setState({
            dropdownOpen: !this.state.dropdownOpen
        });
    }

    dropdownChangeValue = (e) => {
        const newLanguage = e.currentTarget.textContent;
        this.setState({
            language: newLanguage,
            fetchedAudio: null // Reset current audio when language changes
        });
        localStorage.setItem('language', newLanguage);
        localStorage.removeItem('audioVerifications');
        this.getAudio(); // Fetch new audio for selected language
    }

    componentDidMount = ()=>{

        if (this.props.user && this.props.user.isAuthenticated) {
            localStorage.removeItem('audioVerifications');
            this.getAudio();
            this.props.getStats()
            .then((stat)=>{
                this.setState({
                    verifyCount:localStorage.getItem('verified')
                });
            });
        }
        
    }

    getAudioForVerificationFromServer = async () => {
        const bearer = 'Bearer ' + localStorage.getItem('token');
            return fetch(baseUrl+`audio/getFileAsync/${this.state.language}`,{
                method: 'GET',
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': bearer
                  },
                credentials: 'same-origin'
            })
            .then(response => {
                if(response.ok){
                    return response.json();
                }
                const error = new Error(`Error ${response.status}: ${response.statusText}`);
                error.response = response;
                throw error;
            })
            .catch(error => {
                console.error('Error fetching audio:', error);
                throw error;  // Re-throw to handle in component
            });
    } 
    
    getAudio = () =>{
        // set audio to be played
        // var verifyAudio = this.verifyAudio.current;
        this.getAudioForVerificationFromServer()
            .then((data)=>{
                if (!data) {
                    console.log("No audio data received");
                    this.setState({
                        fetchedAudio: null,
                        error: "No audio files available for verification"
                    });
                    return;
                }
                
                try {
                    const current = localStorage.getItem('audioVerifications');
                    // console.log("This is current "+current);
                    // if(current===null){
                    //     localStorage.setItem('audioVerifications',JSON.stringify({
                    //         array:data
                    //     }));
                    //     this.setState({
                    //         fetchedAudio:JSON.parse(localStorage.getItem('audioVerifications')).array[0]
                    //     });

                    // }
                    // else{
                    //     var localArray = JSON.parse(localStorage.getItem('audioVerifications')).array;
                    //     localArray=localArray.concat(data);
                    //     console.log(localArray);
                    //     localStorage.setItem('audioVerifications',JSON.stringify({
                    //         array:localArray
                    //     }));
                    //     this.setState({
                    //         fetchedAudio:localArray[0]
                    //     });
                    // }

                    // for emergency when we have to stream from Gdrive
                    // getAudioId(this.state.fetchedAudio.fileName)
                    // .then((resp)=>{
                    //     console.log(resp);
                    //     if(resp.id){
                    //         this.setState({
                    //             audioId:"http://docs.google.com/uc?export=open&id="+resp.id
                    //         })
                    //     }
                    // },(err)=>console.log(err));
                    if (current === null) {
                        localStorage.setItem('audioVerifications', JSON.stringify({
                            array: data
                        }));
                        this.setState({
                            fetchedAudio: data[0]
                        });
                    } else {
                        const localArray = JSON.parse(current).array;
                        const updatedArray = localArray.concat(data);
                        localStorage.setItem('audioVerifications', JSON.stringify({
                            array: updatedArray
                        }));
                        this.setState({
                            fetchedAudio: updatedArray[0]
                        });
                    }
                } catch (err) {
                    console.error("Error processing audio data:", err);
                }
            })
        .catch((error) => {
            console.error("Error fetching audio for verification:", error);
            if (error.response && error.response.status === 404) {
                this.setState({
                    error: "No audio files available for verification at the moment."
                });
            } else  { 
                this.setState({
                    error: "Failed to load audio. Please try again later."
                });
            }
        });
    }

    submitCorrect = () =>{
        this.setState({
            playbackText:"Play",
            isPlaying:false,
            faClass:"fa fa-play ml-1",
            audioId:null
        })
        // send verification result
        this.props.audioVerificationResult(this.state.fetchedAudio._id,1);
        // get new audio
        // this.getAudio();
        // update the Verified count
        // false: Updating Verified
        // true: Updating Recorded
        this.props.updateStatsServer(false)
        .then((resp)=>{
            if(resp.success){
                // this.props.getStats();
                var verifyCount = localStorage.getItem('verified');
                console.log("Updated Verified Count:\n"+typeof(verifyCount));
                localStorage.setItem('verified', parseInt(verifyCount)+1);
                this.setState({
                    verifiedCount:localStorage.getItem('verified')
                });
            }
            else{
                console.log("Didnt work!");
            }
        })
        .catch((err)=>console.log(err));

        // Update Text
        var nextItem = JSON.parse(localStorage.getItem('audioVerifications')).array;
        nextItem.splice(0,1);
        localStorage.setItem('audioVerifications',JSON.stringify({
            array:nextItem
        }));
        
        this.setState({
            fetchedAudio:nextItem.length===0?null:nextItem[0]
        })
        if(nextItem.length<=1){
            this.getAudio();
        }
        // else{
        //     // for emergency when we have to stream from Gdrive
        //     getAudioId(nextItem[0].fileName)
        //     .then((resp)=>{
        //         console.log(resp);
        //         if(resp.id){
        //             this.setState({
        //                 audioId:"http://docs.google.com/uc?export=open&id="+resp.id
        //             })
        //         }
        //     },(err)=>console.log(err));
        // }

        console.log("Inside GetItem: ",JSON.parse(localStorage.getItem('audioVerifications')));
    }

    submitWrong = () =>{
        this.setState({
            playbackText:"Play",
            isPlaying:false,
            faClass:"fa fa-play ml-1",
            audioId:null
        })
        // send verification result
        this.props.audioVerificationResult(this.state.fetchedAudio._id,0);
        localStorage.removeItem('audioVerification');
        // get new audio
        // this.getAudio();
        // update the Verified count
        // false: Updating Verified
        // true: Updating Recorded
        this.props.updateStatsServer(false)
        .then((resp)=>{
            if(resp.success){
                // this.props.getStats();
                var verifyCount = localStorage.getItem('verified');
                console.log("Updated Verified Count:\n"+verifyCount);
                localStorage.setItem('verified', parseInt(verifyCount)+1);
                this.setState({
                    verifiedCount:localStorage.getItem('verified')
                });
            }
            else{
                console.log("Didnt work!");
            }
        })
        .catch((err)=>console.log(err));

        // Update Audio
        var nextItem = JSON.parse(localStorage.getItem('audioVerifications')).array;
        nextItem.splice(0,1);
        localStorage.setItem('audioVerifications',JSON.stringify({
            array:nextItem
        }));
        
        this.setState({
            fetchedAudio:nextItem.length===0?null:nextItem[0]
        })
        if(nextItem.length<=1){
            this.getAudio();
        }        
        // else{
        //     // for emergency when we have to stream from Gdrive
        //     getAudioId(nextItem[0].fileName)
        //     .then((resp)=>{
        //         console.log(resp);
        //         if(resp.id){
        //             this.setState({
        //                 audioId:"http://docs.google.com/uc?export=open&id="+resp.id
        //             })
        //         }
        //     },(err)=>console.log(err));
        // }
        console.log("Inside GetItem: ",JSON.parse(localStorage.getItem('audioVerifications')));
    }

    // custom playback control
    playbackButtonSubmit = ()=>{
        console.log(this.state.audioId);
        var playbackAudio = this.verifyAudio.current;
        playbackAudio.volume=1;
        if(!this.state.isPlaying){
            this.setState({
                playbackText:"Pause",
                isPlaying:!this.state.isPlaying,
                faClass:"fa fa-pause ml-1"
            });
            console.log("Herer");
            playbackAudio.play();
        }
        else{
            this.setState({
                playbackText:"Play",
                isPlaying:!this.state.isPlaying,
                faClass:"fa fa-play ml-1"
            });
            playbackAudio.pause();
        }
    }

    playbackOnEnd = () =>{
        this.setState({
            playbackText:"Play",
            isPlaying:!this.state.isPlaying,
            faClass:"fa fa-play ml-1"
        });
    }

    buffering = ()=>{
        this.setState({
            playbackText:"Loading..."
        })
    }

    onPlaying = ()=>{
        this.setState({
            playbackText:"Pause",
            faClass:"fa fa-pause ml-1"
        })
    }
    
    render() {
        
        
        // const { error, fetchedAudio } = this.state;

        // if (error) {
        //     return (
        //         <div className="alert alert-danger mt-4">
        //             {error}
        //         </div>
        //     );
        // }

        if (!this.props.user?.isAuthenticated) {
            console.log("Not authenticated, redirecting...");
            return (
                <Redirect to='/' />
            );
        }

        return (
            <div> 
                <Dropdown
                    isOpen={this.state.dropdownOpen}
                    toggle={this.toggleDropdown}
                    // onClick={this.onClickDropdown}
                >
                    <DropdownToggle caret color="success">
                        {this.state.language}
                    </DropdownToggle>
                    <DropdownMenu style={{ width: "max-content" }}>
                        <DropdownItem onClick={this.dropdownChangeValue}><strong>ENG</strong></DropdownItem>
                        <DropdownItem onClick={this.dropdownChangeValue}><strong>HIN</strong></DropdownItem>
                    </DropdownMenu>
                </Dropdown>


                {this.state.fetchedAudio === null ? (
                    <div 
                        className="mt-4 pb-2 pl-2 pr-2">
                        <LoadingAudio/>
                    </div>
                ) : (
                    <div className="verifyDiv mt-2 pb-2 pl-2 pr-2">
                        <div className="row">
                            <div className="ml-auto mr-3">
                                <div className="ml-auto">
                                    <h5>
                                        <Badge color="warning">
                                            Verified {localStorage.getItem('verified')}
                                        </Badge>
                                    </h5>
                                </div>
                            </div>
                        </div>
                        <div className="mt-1" >
                            <div className="row mt-auto ">
                                <div className="col">
                                    <div className="row m-auto">
                                        <div>
                                            <h6><Badge>Listen</Badge></h6>
                                        </div>
                                        <div className="ml-auto">
                                            <h6><Badge color="info">Speaker: {this.state.fetchedAudio.speaker[0].name}</Badge></h6>
                                        </div>
                                        <div className="ml-2">
                                            <h6>
                                                <Badge color={this.state.fetchedAudio.hindiText[0].checked ? "success" : "secondary"}>
                                                    {this.state.fetchedAudio.hindiText[0].checked ? "Checked" : "Unchecked"}
                                                </Badge>
                                            </h6>
                                        </div>
                                    </div>
                                    <h5>{this.state.fetchedAudio.hindiText[0].hindiText}</h5>
                                </div>
                            </div>
                            <div className="row">
                                <div className="ml-3">
                                    <audio
                                        onWaiting={this.buffering}
                                        onPlaying={this.onPlaying}
                                        ref={this.verifyAudio} 
                                        controlsList="nodownload"
                                        // src={this.state.audioId}
                                        src={
                                            "https://datastack.ddns.net:3443/"+this.state.fetchedAudio.fileName
                                            // "https://datastack.ml/serverApi/audio/"+this.state.fetchedAudio.fileName+".wav"
                                        }
                                        onEnded={this.playbackOnEnd}>
                                        This Browser is not supported.<br/> Download Latest Chrome or Firefox browser.</audio>
                                    {/* <div>
                                        <Button
                                        onClick={this.playbackButtonSubmit}
                                        style={{
                                            backgroundColor:"#343a40"
                                        }}
                                        >
                                        {this.state.playbackText}<i className={this.state.faClass}></i></Button>
                                    </div> */}
                                </div>
                                <div className="row ml-auto mr-4">
                                    <div>
                                        <Button color="danger"
                                            onClick={()=>this.submitWrong()}
                                            ><i  className="fa fa-times" aria-hidden="true"></i></Button>
                                    </div>
                                    <div className="ml-2">
                                        <Button color="success"
                                            onClick={()=>this.submitCorrect()}
                                            ><i  className="fa fa-check" aria-hidden="true"></i></Button>
                                    </div>
                                    {/* <div className="ml-2">
                                        <Button
                                        disabled={this.state.audioId===null?true:false}
                                        onClick={this.playbackButtonSubmit}
                                        style={{
                                            backgroundColor:"#343a40"
                                        }}
                                        >
                                        {this.state.audioId===null?"Loading..":this.state.playbackText}<i className={this.state.faClass}></i></Button>
                                    </div> */}
                                    <div className="ml-2">
                                        <Button
                                        onClick={this.playbackButtonSubmit}
                                        style={{
                                            backgroundColor:"#343a40"
                                        }}
                                        >
                                        {this.state.playbackText}<i className={this.state.faClass}></i></Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>)}
            </div>
        );
    };
    
}

export default AudioVerification;

// // import React, { useState, useEffect, useRef } from 'react';
// import { useState, useEffect, useRef  } from 'react';

// const AudioVerification = ({ 
//   getAudioForVerification, 
//   audioVerificationResult,
//   updateStatsServer,
//   getStats 
// }) => {
//   const [audioData, setAudioData] = useState(null);
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [playbackText, setPlaybackText] = useState("Play");
//   const [faClass, setFaClass] = useState("ml-1 fa fa-play");
//   const [verificationCount, setVerificationCount] = useState(
//     localStorage.getItem('verified') || "0"
//   );
  
//   const audioRef = useRef(null);

//   useEffect(() => {
//     fetchNextAudio();
//   }, []);

//   const fetchNextAudio = async () => {
//     try {
//       const data = await getAudioForVerification();
      
//       if (!data) {
//         return;
//       }

//       if (localStorage.getItem('audioVerifications') === null) {
//         localStorage.setItem('audioVerifications', JSON.stringify({
//           array: [data]
//         }));
//         setAudioData(data[0]);
//       } else {
//         const localArray = JSON.parse(localStorage.getItem('audioVerifications')).array;
//         const updatedArray = localArray.concat(data);
//         localStorage.setItem('audioVerifications', JSON.stringify({
//           array: updatedArray
//         }));
//         setAudioData(updatedArray[0]);
//       }

//     } catch (err) {
//       console.error("Error fetching audio:", err);
//     }
//   };

//   const handleVerification = async (isCorrect) => {
//     setPlaybackText("Play");
//     setIsPlaying(false);
//     setFaClass("fa fa-play ml-1");

//     // Submit verification
//     await audioVerificationResult(audioData._id, isCorrect ? 1 : 0);

//     // Update stats
//     const response = await updateStatsServer(false);
//     if (response.success) {
//       const verifyCount = localStorage.getItem('verified');
//       const newCount = parseInt(verifyCount) + 1;
//       localStorage.setItem('verified', newCount);
//       setVerificationCount(newCount);
//     }

//     // Get next audio
//     const nextItems = JSON.parse(localStorage.getItem('audioVerifications')).array;
//     nextItems.splice(0, 1);
//     localStorage.setItem('audioVerifications', JSON.stringify({
//       array: nextItems
//     }));

//     setAudioData(nextItems.length === 0 ? null : nextItems[0]);

//     if (nextItems.length <= 1) {
//       fetchNextAudio();
//     }
//   };

//   const handlePlayback = () => {
//     if (!audioRef.current) return;

//     if (!isPlaying) {
//       audioRef.current.play();
//       setPlaybackText("Pause");
//       setIsPlaying(true);
//       setFaClass("fa fa-pause ml-1");
//     } else {
//       audioRef.current.pause();
//       setPlaybackText("Play");
//       setIsPlaying(false);
//       setFaClass("fa fa-play ml-1");
//     }
//   };

//   const onPlaybackEnd = () => {
//     setPlaybackText("Play");
//     setIsPlaying(false);
//     setFaClass("fa fa-play ml-1");
//   };

//   if (!audioData) {
//     return (
//       <div className="mt-4 pb-2 pl-2 pr-2">
//         <LoadingAudio />
//       </div>
//     );
//   }

//   return (
//     <div className="verifyDiv mt-2 pb-2 pl-2 pr-2">
//       <div className="row">
//         <div className="ml-auto mr-3">
//           <h5>
//             <Badge color="warning">
//               Verified {verificationCount}
//             </Badge>
//           </h5>
//         </div>
//       </div>

//       <div className="mt-1">
//         <div className="row mt-auto">
//           <div className="col">
//             <div className="row m-auto">
//               <div>
//                 <h6><Badge>Listen</Badge></h6>
//               </div>
//               <div className="ml-auto">
//                 <h6>
//                   <Badge color="info">
//                     Speaker: {audioData.speaker[0].name}
//                   </Badge>
//                 </h6>
//               </div>
//             </div>
//             <h5>{audioData.hindiText[0].hindiText}</h5>
//           </div>
//         </div>

//         <div className="row">
//           <div className="ml-3">
//             <audio
//               ref={audioRef}
//               controlsList="nodownload"
//               src={`${window.location.origin}/audio/${audioData.fileName}.wav`}
//               onEnded={onPlaybackEnd}
//             />
//           </div>

//           <div className="row ml-auto mr-3">
//             <div>
//               <Button 
//                 color="danger"
//                 onClick={() => handleVerification(false)}
//               >
//                 <i className="fa fa-times" aria-hidden="true"></i>
//               </Button>
//             </div>
//             <div className="ml-2">
//               <Button 
//                 color="success"
//                 onClick={() => handleVerification(true)}
//               >
//                 <i className="fa fa-check" aria-hidden="true"></i>
//               </Button>
//             </div>
//             <div className="ml-2">
//               <Button
//                 onClick={handlePlayback}
//                 style={{
//                   backgroundColor: "#343a40"
//                 }}
//               >
//                 {playbackText}
//                 <i className={faClass}></i>
//               </Button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AudioVerification;